/**
 * Created by andywiranatawijaya on 8/4/16.
 */


import ApiEndpoint from '../utilities/apiEndpoint.js';
import CONS from '../utilities/constants.js';

class Util {
	// @deprecated
	static getApiEndpoint(isAnonymous, rootName = '', uid = '', date = new Date()) {
		const strDate = date.getFullYear() + (`0${date.getMonth() + 1}`).slice(-2) + (`0${date.getDate()}`).slice(-2);

		return ApiEndpoint.BASE_URL + (isAnonymous ? `anonymous/${strDate}/` : rootName) + uid;
	}

	static getStrDate() {
		const date = new Date();
		const strDate = date.getFullYear() + (`0${date.getMonth() + 1}`).slice(-2) + (`0${date.getDate()}`).slice(-2);
		return strDate;
	}

	static getDefaultApiEndpoint() {
		return ApiEndpoint.BASE_URL;
	}

	static isRedefinedObj(object) {
		return (typeof object !== 'undefined');
	}

	/**
     *     deprecated please use object != null
     */
	static isNotNullAndDefined(object) {
		return (object !== null && typeof (object) !== 'undefined');
	}

	static getPagingSize() {
		if (typeof window !== 'undefined') {
			if (window.innerWidth > 1170) {
				return CONS.PAGING_HOME_LARGE_SCREEN;
			} else if (window.innerWidth > 970) {
				return CONS.PAGING_HOME;
			}
			return CONS.PAGING_HOME_MOBILE;
		}
		return CONS.PAGING_HOME_MOBILE;
	}

	static isMobileDevice() {
		if (typeof (navigator) === 'undefined') {
			return false;
		}
		if (navigator.userAgent.match(/Android/i)
                || navigator.userAgent.match(/webOS/i)
                || navigator.userAgent.match(/iPhone/i)
                || navigator.userAgent.match(/iPad/i)
                || navigator.userAgent.match(/iPod/i)
                || navigator.userAgent.match(/BlackBerry/i)
                || navigator.userAgent.match(/Windows Phone/i)
		) {
			return true;
		}

		return false;
	}

	static isIos() {
		return !!window.navigator.userAgent.match(/iPad|iPhone/i);
	}
	static isValidEmail(value) {
		const re = CONS.REGEX_EMAIL;
		const reStatus = re.test(value);
		let isValidEmail = reStatus;

		if (reStatus === false) {
			return isValidEmail;
		}

		if (CONS.IS_PRODUCTION_MODE) {
			let mailinatorStatus = false;

			if (value.indexOf('@mailinator.com') < 0) {
				mailinatorStatus = true;
			}
			if (reStatus === true && mailinatorStatus === true) {
				isValidEmail = true;
			} else {
				isValidEmail = false;
			}
		}

		return isValidEmail;
	}

	static removeZeroNumber(phoneNumber) {
		let number = phoneNumber;
		while (number.charAt(0) === '0') { number = number.substr(1); }
		return number;
	}

	static formatPrice(total) {
		return (`${total}`).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
	}

	static getNameFromEmail(email) {
		if (email != null) {
			const fields = email.split('@');
			if (fields != null && fields.length === 2) {
				return fields[0];
			}
		}
		return '';
	}

	static getDeliveryDateId(deliveryDate) {
		if (deliveryDate != null) {
			const fields = deliveryDate.split(',');

			if (fields != null && fields.length === 2) {
				const day = CONS.DELIVERY_DAY_ID[fields[0]];
				const dates = (fields[1].trim()).split(' ');
				let date = '';

				if (dates != null && dates.length === 3) {
					date = `${dates[0]} ${CONS.DELIVERY_MONTH_ID[dates[1]]} ${dates[2]}`;

					return (`${day}, ${date}`);
				}
			}
		}
		return '';
	}
}


export default Util;



// WEBPACK FOOTER //
// ./src/app/utilities/Util.js